import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import { presetAPI } from '../services/api';
import './ItineraryPresets.css';

const ItineraryPresets = () => {
  const navigate = useNavigate();
  const [presets, setPresets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetch = async () => {
      try {
        const data = await presetAPI.getAll();
        setPresets(data.data || data.presets || data || []);
      } catch {
        setError('Failed to load presets.');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);

  if (loading) return <Layout title="Preset Editor"><div className="itin-loading">Loading...</div></Layout>;
  if (error)   return <Layout title="Preset Editor"><div className="itin-error">{error}</div></Layout>;

  return (
    <Layout title="Preset Editor">
      <div className="itin-presets">
        <div className="itin-page-header">
          <h2>Preset Editor</h2>
          <span className="itin-total-badge">{presets.length} presets</span>
        </div>

        <div className="itin-preset-grid">
          {presets.length === 0 ? (
            <div className="itin-empty">No presets found.</div>
          ) : presets.map(preset => {
            const total    = preset.total_attractions ?? preset.attractions?.length ?? 0;
            const matched  = preset.matched_count ?? preset.attractions?.filter(a => a.matched)?.length ?? 0;
            const coverage = total > 0 ? Math.round((matched / total) * 100) : 0;

            return (
              <div
                key={preset.id}
                className="itin-preset-card"
                onClick={() => navigate(`/itinerary/presets/${preset.id}`)}
              >
                <div className="itin-preset-icon">🗂️</div>
                <div className="itin-preset-body">
                  <div className="itin-preset-title">{preset.title || preset.name || `Preset #${preset.id}`}</div>
                  {preset.theme && <div className="itin-preset-theme">{preset.theme}</div>}
                  <div className="itin-preset-stats">
                    <div className="itin-preset-stat">
                      <span>Total Attractions</span>
                      <strong>{total}</strong>
                    </div>
                    <div className="itin-preset-stat">
                      <span>Matched</span>
                      <strong>{matched}</strong>
                    </div>
                    <div className="itin-preset-stat">
                      <span>Coverage</span>
                      <strong className={coverage < 80 ? 'warn' : 'ok'}>{coverage}%</strong>
                    </div>
                  </div>
                  <div className="itin-coverage-bar-track">
                    <div
                      className={`itin-coverage-bar-fill ${coverage < 60 ? 'red' : coverage < 80 ? 'orange' : 'green'}`}
                      style={{ width: `${coverage}%` }}
                    />
                  </div>
                  {matched < total && (
                    <div className="itin-preset-warning">⚠️ {total - matched} unmatched attraction{total - matched !== 1 ? 's' : ''}</div>
                  )}
                </div>
                <div className="itin-preset-arrow">→</div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default ItineraryPresets;
